import { GetDailyFooterStatsDto } from "../../model/footer-daily-stats/dto/GetDailyFooterStatsDto";
import { GetFooterDailyStatsResponseDto } from "../../model/footer-daily-stats/dto/GetFooterDailyStatsResponseDto";
import { AtiraApi } from "../AxiosClient";

export class FooterDailyStatsAxios {
  static getDailyStats(dto: GetDailyFooterStatsDto) {
    return AtiraApi.post<GetFooterDailyStatsResponseDto>(
      `/dashboard/footer/stats`,
      dto,
    ).then(({ data }) => data);
  }
}
